import { render } from "./ContactSubmit.vue?vue&type=template&id=8b7fad90"
import script from "./ContactSubmit.vue?vue&type=script&lang=js"
export * from "./ContactSubmit.vue?vue&type=script&lang=js"

import exportComponent from "M:\\Me\\WebPortfolio_2022\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__